import { render, staticRenderFns } from "./WizardForm.vue?vue&type=template&id=5cf9e636"
import script from "./WizardForm.vue?vue&type=script&lang=js"
export * from "./WizardForm.vue?vue&type=script&lang=js"
import style0 from "./WizardForm.vue?vue&type=style&index=0&id=5cf9e636&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports